import React from 'react';
import { ProjectCard } from './ProjectCard';
import { useLang } from '../i18n/LanguageContext';

// Media config is language-agnostic. Order matches translations.items[].
const projectsMedia = [
  // 0. Basics by GOIKO — Enjoy The Simple Things
  {
    mediaType: 'gallery',
    media: [
      { type: 'image', src: '/images/basics-1.jpg' },
      { type: 'image', src: '/images/basics-2.jpg' },
      { type: 'image', src: '/images/basics-3.jpg' },
      { type: 'image', src: '/images/basics-4.jpg' },
      { type: 'video', src: 'https://player.vimeo.com/video/1191608394?badge=0&autopause=0&player_id=0&app_id=58479' },
    ],
    mediaAspect: '16:9',
  },
  // 1. Game On MTFs
  {
    mediaType: 'video',
    videoUrl: 'https://www.youtube.com/embed/B2HUu1YgszE?rel=0&modestbranding=1',
    mediaAspect: '16:9',
  },
  // 2. Pink's x Dani Brasserie
  {
    mediaType: 'gallery',
    media: [
      { type: 'video', src: 'https://player.vimeo.com/video/1191309437?badge=0&autopause=0&player_id=0&app_id=58479' },
      { type: 'image', src: '/images/pinks-dani-4.jpg' },
      { type: 'image', src: '/images/pinks-dani-2.jpg' },
      { type: 'image', src: '/images/pinks-dani-3.jpg' },
      { type: 'image', src: '/images/pinks-dani-1.jpg' },
    ],
    mediaAspect: '16:9',
  },
  // 3. Perri's
  {
    mediaType: 'gallery',
    images: [
      '/images/perris-1.png',
      '/images/perris-2-optimized.jpg',
      '/images/perris-3-optimized.jpg',
      '/images/perris-4-optimized.jpg',
      '/images/perris-5-optimized.jpg',
    ],
    mediaAspect: '16:9',
  },
  // 4. Telpark
  {
    mediaType: 'video',
    videoUrl: 'https://www.youtube.com/embed/Ma4lyGVUhn8?si=jr4BOfFx0s5aQD0v',
    mediaAspect: '16:9',
  },
  // 5. Incógnito Smash
  {
    mediaType: 'video',
    videoUrl: 'https://www.youtube.com/embed/xJmOvZ53BLE?si=q4RjDod9Lt7UsB4e',
    mediaAspect: '16:9',
    behanceUrl: 'https://www.behance.net/gallery/198656283/Incognito-Smash-x-Ceciarmy',
  },
];

export const Projects = () => {
  const { t } = useLang();
  const projects = t.projects.items.map((item, idx) => ({
    ...item,
    ...projectsMedia[idx],
  }));

  return (
    <section id="projects" className="py-8 lg:py-12 bg-muted/5">
      <div className="section-container">
        <div className="max-w-3xl mb-16">
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-semibold mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {t.projects.title}
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            {t.projects.intro}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:gap-12">
          {projects.map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 text-sm text-muted-foreground px-6 py-3 border border-dashed border-muted rounded-sm">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            <span>{t.projects.moreAvailable}</span>
          </div>
        </div>
      </div>

      <div className="section-divider" />
    </section>
  );
};
